import React, { lazy, useEffect, useState } from "react";
import { useAppSelector } from "@/redux-config/hooks";
import { selectUser } from "@/redux-config/entities/user";
import { useTranslation } from "react-i18next";
import { selectLanguage } from "@/redux-config/entities/language";
import { Helmet } from "react-helmet";
import { CustomBreadCrumb } from "@/components/customBreadCrumb";

import CKeditor from "@/components/ck-editor";

export const AboutUs: React.FC<{}> = () => {
  const user = useAppSelector(selectUser);
  const { t } = useTranslation();

  const crumbs = [
    { name: t("Dashboard"), href: "/" },
    { name: t("AboutUs"), href: "#" },
  ];
  const lng = useAppSelector(selectLanguage);

  const [editorLoad, setEditorLoad] = useState<boolean>(false);

  useEffect(() => {
    setEditorLoad(true);
  }, []);

  return (
    <>
      <Helmet>
        <title>MahdiBookShop | AboutUs</title>
        <meta name="description" content="Basic example" />
      </Helmet>
      <div className="d-flex flex-column">
        <CustomBreadCrumb breadCrumbList={crumbs} />
        <div className={"d-flex flex-row flex-wrap"}>
          <div className={"col-12 p-2"}>
            <div className={"d-flex flex-column bg-custom-white rounded-3 p-3"}>
              <CKeditor
                onChange={(data: string) => {
                  console.log(data);
                }}
                value={""}
                editorLoaded={editorLoad}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
